<template>
	<div ref="myElement" class="container">
		<div class="main_box">
			<!--块1-->
			<div class="block_1">
				<div class="block_1_main">
					<div v-if="newsList.length > 0" class="list_box" v-loading="listLoading">
						<div
							v-for="(value, index) in newsList"
							:key="index"
							class="list_el"
							data-aos="fade-in"
							data-aos-duration="400"
							data-aos-delay="100"
							data-aos-offset="0"
							data-aos-once="true"
							@click="goInfo(value)"
						>
							<div class="tit">{{ value.title }}</div>
							<div class="msg_box">
								<div class="left">
									<img :src="webUrl + value.image" />
								</div>
								<div class="right">
									<div class="txt">{{ value.description }}</div>
									<div class="time">{{ value.fabu_time }}</div>
								</div>
							</div>
						</div>
					</div>
					<div v-if="newsList.length > 0" class="page_box"
						data-aos="fade-in"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
					>
						<el-pagination
							:small="false"
							background
							layout="prev, pager, next"
							:total="total"
							:page-size="10"
							@current-change="pageChange"
						>
						</el-pagination>
					</div>
				</div>
			</div>
			<!--块1-->
		</div>
	</div>
</template>

<script>
import { newsList } from '@/api/public';  //新闻列表
import { UPURL } from '@/util/util';
export default {
	components:{
		//
	},
	data() {
		return {
			newsList: [],
			page: 1,
			total: 0,
			listLoading: true,
			webUrl: UPURL,
		}
	},
	created(){
		let that = this;
	},
	mounted() {
		let that = this;
		//获取新闻列表
		that.$toast.loading({ message: '', forbidClick: true, duration: 0 });
		that.getList();
	},
	watch: {
		//
	},
	methods: {
		//分页点击
		pageChange(val) {
			let that = this;
			that.page = val;
			that.getList(true);
		},
		//获取列表
		getList(type) {
			let that = this;
			that.listLoading = true;
			newsList({
				page: that.page,
				page_size: 10,
				leixing: 2,
				language: sessionStorage.getItem('lang')
			}).then(res => {
				that.newsList = res.data.data;
				that.total = res.data.total;
				that.listLoading = false;
				that.$toast.clear();
				if(type) {
					//滚动到列表顶部
					that.$refs.myElement.scrollIntoView({ behavior: 'smooth' });
				}
			});
		},
		//点击查看详情
		goInfo(value) {
			let that = this;
			let routeData = that.$router.resolve({name: "NewsInfo", params: { newInfoId: value.id + '.html' } });
			window.open(routeData.href, '_blank');
		},
	}
}
</script>

<style lang="less" scoped>
.main_box{
	//块1
	.block_1{
		padding: 60px 0 80px 0;
		background-color: #F7F6F9;
		.block_1_main{
			width: 1264px;
			margin: 0 auto;
			.page_box{
				padding-top: 50px;
				text-align: center;
			}
			.list_el{
				display: inline-block;
				width: 47%;
				margin: 20px 1.5% 20px 1.5%;
				padding: 36px 30px;
				background-color: #ffffff;
				border-radius: 8px;
				cursor: pointer;
				.msg_box{
					display: flex;
					padding-top: 20px;
					.right{
						flex: 1;
						position: relative;
						padding-left: 24px;
						.time{
							position: absolute;
							bottom: 0;
							font-size: 16px;
							color: #999999;
						}
						.txt{
							overflow: hidden;
							text-overflow: ellipsis;
							display: -webkit-box;
							-webkit-line-clamp: 3;
							-webkit-box-orient: vertical;
							font-size: 16px;
							color: #666666;
						}
					}
					.left{
						width: 200px;
						height: 150px;
						img{
							width: 100%;
							height: 100%;
							object-fit: contain;
						}
					}
				}
				.tit{
					height: 76px;
					overflow: hidden;
					text-overflow: ellipsis;
					display: -webkit-box;
					-webkit-line-clamp: 2;
					-webkit-box-orient: vertical;
					font-size: 24px;
				}
			}
		}
	}
}
</style>
<style scoped>
/*分页*/
>>> .page_box .el-pager li:hover{
	color: #A50073 !important;
}
>>> .page_box .el-pagination.is-background .el-pager li:not(.disabled).active{
	background-color: #A50073 !important;
}
>>> .page_box .el-pagination.is-background .el-pager li:not(.disabled).active:hover{
	color: #ffffff !important;
}
</style>